import { Capacitor } from "@capacitor/core";

import type { WebFilterStatus } from "./plugins";

/** iOS/Android native — the only platforms where typed website targets require VPN. */
export function isNativeWebFilterVpnPlatform(): boolean {
  return (
    Capacitor.isNativePlatform() &&
    (Capacitor.getPlatform() === "ios" || Capacitor.getPlatform() === "android")
  );
}

/**
 * True when the user must install the on-device web-filter VPN profile before adding
 * typed domains or website categories. Matches orchestration `needs_install` semantics
 * but does not require VPN to be enabled/active.
 */
export function requiresVpnForTypedWebEditing(status: WebFilterStatus): boolean {
  if (!isNativeWebFilterVpnPlatform()) return false;
  return !status.installed || status.status === "not_installed" || status.status === "denied";
}
